export default __webpack_public_path__ + "static/media/find-substitute.bc90d0ac.svg";